import React from 'react'
import { motion, AnimatePresence } from 'framer-motion'

const Panel = ({ title, content, position, link }) => {

	const variants = {
		in: { opacity: 1, y: 0, transition: { type: 'spring', duration: .1, stiffness: 150 } },
		out: { opacity: 0, y: 50, transition: { type: 'tween', duration: .2 } }
	}

	return (
		<motion.div
			variants={variants}
			initial="out"
			animate="in"
			exit="out"
			className="Popup-Panel"
			style={{
				top: `${position.top}px`,
				left: `${position.left}px`,
			}}
		>
			<p className="title">{title}</p>
			<div className="content" dangerouslySetInnerHTML={{__html: content}} />
			{link && <a className="Popup-Panel-Button" href={link.url} aria-label="Go to section"><span dangerouslySetInnerHTML={{__html: link.title}} /></a>}
		</motion.div>
	)
}

export default ({settings, content, development, active, id, setActive}) => {

	return (
		<div
			className={active ? 'Popup-area active' : 'Popup-area'}
			style={{
				width: `${settings.area.width}%`,
				height: `${settings.area.height}%`,
				bottom: `${settings.area.bottom}%`,
				left: `${settings.area.left}%`,
			}}
			data-develop={false}
		>
			<div
				className={`Popup-point ${active ? 'active' : ''}`}
				style={{
					top: `${settings.point.top}%`,
					left: `${settings.point.left}%`,
				}}
			>
				<button  onClick={() => setActive(id)}>
					<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="10" cy="10" r="10" fill="#F84C5B" />
						<path d="M9.1998 10.8002V15.2002H10.7998V10.8002H15.1998V9.2002H10.7998V5.2002H9.1998V9.2002H4.7998V10.8002H9.1998Z" fill="#FDFEFF" />
					</svg>
				</button>
				<AnimatePresence>
					{
						active && <Panel {...content} position={settings.panel} />
					}
				</AnimatePresence>
			</div>
		</div>
	)
}